<template>
    <div class="flex-container" id="callback">
        <form id="form" class="flex-item col-12 margin-0" v-on:submit.prevent="submit">
            <div class="flex-item col-12">
                <label for="fullName">{{ translations.fullName }} <span>*</span></label>
                <input v-model="fullName" type="text" required class="form-control" id="fullName" :placeholder="translations.fullNameplaceholder" />
            </div>

            <div class="flex-item col-12">
                <label for="orderNumber">{{translations.ordernumber}}</label>
                <input v-model="orderReference" type="number" class="form-control" id="orderNumber" placeholder="21686939">
                <small class="form-text text-muted">{{translations.ordernumberhelp}}</small>
            </div>

            <div class="flex-item col-12">
                <label for="telNumber">{{translations.telnumber}} <span>*</span></label>
                <input v-model="telNo" type="number" required class="form-control" id="telNumber" placeholder="07700000000">
            </div>

            <div class="flex-item col-12">
                <label for="email">{{translations.email}} <span>*</span></label>
                <input v-model="email" type="email" class="form-control" required id="email" :placeholder="translations.emailplaceholder">
                <small class="form-text text-muted">{{translations.neverShare}} <a href="https://www.regatta.pl/polityka-prywatnosci/" target="_blank">{{translations.neverShareLink}}</a> </small>
            </div>

            <div class="flex-item col-12">
                <label for="comment">
                    <div>{{translations.callbackmessage}} <span>*</span></div>
                </label>
                <textarea v-model="callbackmessage" type="text" required class="form-control" id="comment" :placeholder="translations.callbackmessageplaceholder"></textarea>
            </div>

            <div class="flex-item col-12 flex-container" v-if="successMessage === 'yes' " id="successMessage" @click="closeSuccessMessage()">
                <h2>{{translations.thankyou}}</h2>
                <div>{{translations.successmessage1}} {{translations.successmessage2}}</div>
            </div>

            <button type="submit" class="btn btn-primary">
                <div class="spinner-border" role="status" v-if="sendState === 'sending'">
                    <span class="sr-only">{{ translations.sending }} </span>
                </div>
                <div v-if="sendState != 'sending'">{{ translations.submit }}</div>
            </button>
        </form>
    </div>
</template>

<script>
const axios = require("axios");
import jsonFile from "./translations.json";

export default {
    name: "app",
    mounted: function() {
        this.onPageLoad();
    },
    data() {
        return {
            brand: null,

            sendState: "default",
            fullName: null,
            orderReference: null,
            telNo: null,
            email: null,
            callbackmessage: "",
            successMessage: null,
            translations: "",
        };
    },
    methods: {
        onPageLoad: function() {
            document.getElementsByTagName("html")[0].setAttribute("data-brand", this.$router.currentRoute.params.pathMatch);
            document.getElementsByTagName("html")[0].setAttribute("data-lang", this.$router.currentRoute.query.lang);

            console.log(this.$router.currentRoute);

            this.brand = this.$router.currentRoute.params.pathMatch;

            var key = this.$router.currentRoute.query.lang;
            var translationsUK = jsonFile.uk;
            var translationsFR = jsonFile.fr;
            var translationsDE = jsonFile.de;
            var translationsPL = jsonFile.pl;

            if (key == "uk") {
                this.translations = translationsUK;
            }
            if (key == "us") {
                this.translations = translationsUK;
            }
            if (key == "eu") {
                this.translations = translationsUK;
            }
            if (key == "ie") {
                this.translations = translationsUK;
            }
            if (key == "fr") {
                this.translations = translationsFR;
            }
            if (key == "de") {
                this.translations = translationsDE;
            }
            if (key == "pl") {
                this.translations = translationsPL;
            }
        },
        closeSuccessMessage: function() {
            this.successMessage = null;
        },
        submit: function() {
            console.log('trying...')
            this.sendState = "sending";

            var params = {
                "request": {
                    "subject": "Request Callback",
                    "comment": {
                        "html_body": "<strong>Request Callback: </strong>" + this.fullName + "</br>" +
                            "<strong>Order Reference:</strong> " + this.orderReference + "</br>" +
                            "<strong>Telephone Number: </strong> " + this.telNo + "</br>" +
                            "<strong>Email Address: </strong> " + this.email + "</br>" +
                            "<strong>Query:</strong> " + this.callbackmessage,
                    },
                    
                    "custom_fields": [
                        {
                            "id": "360007768460",
                            "value": this.orderReference,
                        },
                        {
                            "id": "8584480267921",
                            "value": this.telNo,
                        },
                        {
                            "id": "360007784519",
                            "value": this.callbackmessage,
                        }
                    ],
                    "tags": [this.$router.currentRoute.params.pathMatch + "_" + this.$router.currentRoute.query.lang, "callback_form"],

                    "requester": {
                        "email": this.email,
                        "role": "end-user",
                        "name": this.fullName,
                    },
                },
            };

            console.log(params);
            console.log("https://regatta.zendesk.com/api/v2/requests.json" + params)
            axios
                .post("https://regatta.zendesk.com/api/v2/requests.json", params)
                .then((resp) => {
                    this.fullName = this.email = this.orderReference = this.telNo = this.callbackmessage = ""; // makes all entries blank
                    console.log(resp.status);
                    this.sendState = "";
                    this.successMessage = "yes";
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};

setInterval(function() {
    window.top.postMessage(document.body.scrollHeight, "*");
}, 150);
</script>
